// Error.js
import { useEffect, useRef } from "react";

export const Error = ({ errorMessage }) => {
  const divRef = useRef(null);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  if (!errorMessage) return null;

  return (
    <div
      role="alert"
      aria-label={errorMessage}
      className="form-text text-danger mt-1"
      ref={divRef}
    >
      {errorMessage}
    </div>
  );
};
